import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { publicIdSchema } from "./public-id";

export const builtInTemplateSchema = z.enum([
  "SOAP Template",
  "Specialist Template",
  "Voice to Text Dictation",
]);

export const accountDefaultTemplateSchema = z.object({
  template: z.union([builtInTemplateSchema, z.literal("Custom")]),
  customTemplatePublicId: publicIdSchema.nullable(),
  source: z.enum(["custom", "account", "fallback"]),
});

export const accountDefaultTemplateUpdateSchema = z.union([
  z.strictObject({ template: builtInTemplateSchema }),
  z.strictObject({ customTemplatePublicId: publicIdSchema }),
]);

const base = oc.errors({
  BAD_REQUEST: { message: "Invalid request" },
  METHOD_NOT_ALLOWED: { message: "Method Not Allowed" },
  INTERNAL_SERVER_ERROR: { message: "Internal Server Error" },
  UNAUTHORIZED: { message: "Authentication required" },
  FORBIDDEN: { message: "Account required" },
  SERVICE_UNAVAILABLE: { message: "Authentication unavailable" },
  NOT_FOUND: { message: "Not Found" },
});

export const accountDefaultTemplateContract = {
  myDefaultTemplate: base
    .input(z.strictObject({}))
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/me/default-template",
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(accountDefaultTemplateSchema),
  setMyDefaultTemplate: base
    .input(
      z.object({
        query: z.strictObject({}).default({}),
        body: accountDefaultTemplateUpdateSchema,
      }),
    )
    .meta(
      openapi({
        method: "PUT",
        path: "/api/v2/me/default-template",
        inputStructure: "detailed",
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(accountDefaultTemplateSchema),
};
